import { a as o_global } from "../chunks/common-namespaces-client-DhfOpdyM.mjs";
const breakpoint = o_global.breakpoint ?? {};
const globalBreakpoint = o_global.globalBreakpoint;
export {
  breakpoint,
  globalBreakpoint
};
/*                                          */
